import type { HttpRequestCancelFilters } from 'http'
import {
  HttpService,
  EventService,
  EventPageKitService,
  PageKitService,
  LayoutService,
  OrderKitService,
  ProfileService,
  LocationService,
  SearchService,
  OrderService,
  FeedbackService,
  AuthenticationAttemptService,
  RefreshAttemptService,
  PaymentService,
  WidgetConfigurationService,
  CompilationService,
  GroupOrderService,
  CertificateService,
  RegistrationService,
  VenuePageKitService,
  SocialCallbackService,
  RecoveryPasswordService,
  WidgetService,
  DebugService,
  AnnouncementService,
  CaptchaService,
  GeoLocationService,
  NewsPageKitService,
} from '@/services'

export default defineNuxtPlugin((nuxtApp) => {
  const { apiBaseUrl, isWidget } = useRuntimeConfig().public
  const { privateApiBaseUrl } = useRuntimeConfig()
  const event = useRequestEvent()
  const cancelTokenStore = useCancelTokensStore()
  const locationStore = useLocationStore()
  const authStore = useAuthStore()
  const debugStore = useDebugStore()
  const captchaStore = useCaptchaStore()
  const cacheStore = useCacheStore()
  const widgetStore = useWidgetConfigurationStore()
  const setGlobalError = useLayoutStore().setGlobalError

  const widgetService = new WidgetService(isWidget as boolean, widgetStore)

  const httpService = new HttpService(
    nuxtApp,
    {},
    apiBaseUrl,
    privateApiBaseUrl as string,
    navigateTo,
    cancelTokenStore,
    locationStore,
    authStore,
    debugStore,
    cacheStore,
    captchaStore,
    setGlobalError,
    widgetService,
    event,
  )

  const Api = {
    resources: {
      events: new EventService(httpService),
      eventPageKit: new EventPageKitService(httpService),
      venuePageKit: new VenuePageKitService(httpService),
      pageKit: new PageKitService(httpService),
      search: new SearchService(httpService),
      layout: new LayoutService(httpService),
      captcha: new CaptchaService(httpService),
      geoLocation: new GeoLocationService(httpService),
      orderKit: new OrderKitService(httpService),
      profile: new ProfileService(httpService),
      authenticationAttempt: new AuthenticationAttemptService(httpService),
      refreshAttempt: new RefreshAttemptService(httpService),
      location: new LocationService(httpService),
      order: new OrderService(httpService),
      feedback: new FeedbackService(httpService),
      payment: new PaymentService(httpService),
      widgetConfiguration: new WidgetConfigurationService(httpService),
      compilation: new CompilationService(httpService),
      groupOrder: new GroupOrderService(httpService),
      certificate: new CertificateService(httpService),
      registration: new RegistrationService(httpService),
      socialCallback: new SocialCallbackService(httpService),
      recoveryPassword: new RecoveryPasswordService(httpService),
      debug: new DebugService(httpService, apiBaseUrl),
      announcement: new AnnouncementService(httpService),
      newsPageKit: new NewsPageKitService(httpService),
    },
    cancelRequests(filters: HttpRequestCancelFilters) {
      httpService.cancelRequests(filters)
      httpService.cancelRequests(filters)
    },
  }

  return {
    provide: {
      api: Api,
    },
  }
})
